<div fxLayout="row" fxLayoutAlign="start center">
  <h1>
    {{ "MERCHANT.BASIC.EDIT_TITLE" | translate }}
  </h1>

  <div *ngIf="(hasLoadError$ | async) === true" class="spinner-container">
    <span color="warn">{{ "MERCHANT.ERROR.GET" | translate }}</span>
  </div>
</div>

<mat-card>
  <app-merchant-basic-data-form
    *ngIf="isLoaded$ | async"
    [basicData]="data$ | async"
    [isLoading]="false"
    [logoUrl]="logoUrl$ | async"
    [isLogoUpdating]="(isLogoUpdating$ | async) ?? false"
    [updating]="(isUpdating$ | async) ?? false"
    [error]="updateError$ | async"
    (submitData)="onSubmit($event)"
  ></app-merchant-basic-data-form>
</mat-card>
